module.exports = __webpack_public_path__ + "img/role-curator.afc01a6a.png";